module.exports = __webpack_public_path__ + "static/media/octopoda-chloris.dd597262.jpg";